import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import {
  GetPoliciesQuery,
  GetPoliciesResponse,
} from '../models/policy-list.model';

/**
 * Policy List Service
 * Handles HTTP requests for policy list operations
 */
@Injectable({
  providedIn: 'root',
})
export class PolicyListService {
  private readonly baseUrl = `${environment.policyManagementApiUrl}/api/v1/policies`;

  constructor(private http: HttpClient) {}

  /**
   * Get list of policies with pagination and filters
   * @param query Query parameters for filtering and pagination
   * @returns Observable of policies response
   */
  getPolicies(query: GetPoliciesQuery = {}): Observable<GetPoliciesResponse> {
    let params = new HttpParams();

    if (query.page !== undefined) {
      params = params.set('page', query.page.toString());
    }
    if (query.limit !== undefined) {
      params = params.set('limit', query.limit.toString());
    }
    if (query.status) {
      params = params.set('status', query.status);
    }
    if (query.category) {
      params = params.set('category', query.category);
    }
    if (query.orderBy) {
      params = params.set('orderBy', query.orderBy);
    }
    if (query.order) {
      params = params.set('order', query.order);
    }

    return this.http.get<GetPoliciesResponse>(this.baseUrl, {
      params,
    });
  }
}
